module.exports = __webpack_public_path__ + "img/shape_uploaddata_school_id.5e07526c.svg";